import React, { useState } from 'react';
import { makeStyles } from '@material-ui/styles';

const useStyles = makeStyles({
  wrapper: {
    display: 'flex',
    gap: '.5rem'
  },
  flex: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    position: 'relative'
  },
  text: {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    fontWeight: 700
  },
  progress: {
    fill: 'transparent',
    strokeWidth: '6px',
    strokeLinecap: 'round'
  },
  track: {
    fill: 'transparent',
    stroke: 'hsl(0, 0%, 93%)',
    strokeWidth: '6px'
  }
});

interface CircularProgressBarProps {
  value: number;
  display: string;
  color?: string;
  size?: number;
}

const CircularProgressBar = ({
  value,
  display,
  color = 'hsl(161, 100%, 43%)',
  size = 25
}: CircularProgressBarProps) => {
  const classes = useStyles();
  const radius = size - 10;
  const circumference = 2 * Math.PI * radius;
  const [offset, setOffset] = useState(circumference);

  setTimeout(() => {
    setOffset(circumference - (value * circumference) / 100);
  }, 0);

  return (
    <div className={classes.wrapper}>
      <div className={classes.flex}>
        <span className={classes.text}>{display}</span>
        <svg
          style={{
            height: size * 2,
            width: size * 2,
            transform: 'rotate(90deg)'
          }}
        >
          <circle
            className={classes.track}
            cx={size}
            cy={size}
            r={radius}
          ></circle>
          <circle
            className={classes.progress}
            cx={size}
            cy={size}
            r={radius}
            style={{
              strokeDasharray: circumference,
              strokeDashoffset: offset,
              stroke: color,
              transition: 'stroke-dashoffset 0.5s ease-in-out'
            }}
          ></circle>
        </svg>
      </div>
    </div>
  );
};

export default CircularProgressBar;
